import req from '../req'

// 红包配置-保存配置详情接口
export function saveRedEnvelope (params) {
  return req.post('/setting/red-envelope-setting', params)
}
